export default "__VITE_ASSET__DH_3tvJF__"